import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "redux/AxiosClient";
import { isJson } from "utils/isJson";

// Appendix document dropdown (Documents where documentType = 'certificate appendix')
export const getAppendixDocumentDropdownAsync = createAsyncThunk(
  "certificateAppendix/getAppendixDocumentDropdown",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/service/certificate-appendix/document-dropdown?appendixType=${
        payload?.appendixType || ""
      }`,
      [],
      toolkit
    );
  }
);

// Merged (or previously saved) appendix html
export const getAppendixHtmlAsync = createAsyncThunk(
  "certificateAppendix/getAppendixHtml",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/service/certificate-appendix/get-html/${payload?.documentId}/${payload?.certificateId}`,
      [],
      toolkit
    );
  }
);

// Persist the (hand edited) appendix html on the certificate
export const saveAppendixAsync = createAsyncThunk(
  "certificateAppendix/saveAppendix",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/service/certificate-appendix/save/${payload?.certificateId}`,
      {
        documentId: payload?.documentId,
        appendixType: payload?.appendixType,
        previewData: payload?.previewData
      },
      toolkit
    );
  }
);

// Streams the saved appendix as a pdf. The route is behind `auth`, which also
// accepts the jwt as `?token=` (see auth_middleware), so a plain window.open works.
export const appendixPdfDownload = ({ certificateId, documentId }) => {
  window.open(
    `${
      process.env.REACT_APP_BASE_URL
    }/service/certificate-appendix/print-pdf/${certificateId}?documentId=${documentId}&token=${
      isJson(localStorage.getItem("auth"))
        ? JSON.parse(localStorage.getItem("auth"))?.token
        : null
    }`,
    "_parent"
  );
};
